<script>
  import {getContext} from 'svelte';
  import {Collapse, Panel} from '@px/collapse';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  const brandList = {
    safe: [
      {
        title: LG(lang.Trustworthy),
        desc: LG(lang.SinceOurInception),
      },
    ],
    super: [
      {
        title: LG(lang.Transparency),
        desc: LG(lang.FirstExchangeTo),
      },
    ],
    simple: [
      {
        title: LG(lang.Together),
        desc: LG(lang.AnEverGrowing),
      },
    ],
  };
</script>

<style>
  .wrap {
    background: #000;
  }
  .main {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 100px 0;
    width: 1200px;
  }
  .title {
    margin-top: 0;
    margin-bottom: 48px;
    text-align: center;
    font-size: 48px;
  }
  .brand-logo {
    margin-right: 120px;
  }
  .main :global(.panel-wrap) {
    margin-bottom: 40px !important;
    border-color: rgba(255, 255, 255, 0.2);
    background: initial;
  }
  .main :global(.panel-title-wrap) {
    padding: 36px 40px;
  }
  .brand-title {
    margin: 0;
    font-size: 32px;
    color: #fff;
  }
  .main :global(.panel-title-wrap .iconfont) {
    font-size: 20px;
  }
  .brand-content img {
    margin-right: 40px;
  }
  @media screen and (max-width: 640px) {
    .main {
      padding: 24px 20px;
      width: 100%;
    }
    .title {
      margin-bottom: 28px;
      text-align: left;
      font-size: 18px;
    }
    .brand-logo {
      display: none;
    }
    .main :global(.panel-wrap) {
      border: none;
    }
    .main :global(.panel-title-wrap) {
      padding: 16px 0;
    }
    .brand-title {
      font-size: 24px;
    }
    .main :global(.panel-title-wrap .iconfont) {
      font-size: 20px;
    }
    .brand-content {
      flex-direction: column;
    }
    .brand-content img {
      margin-bottom: 24px;
    }
  }
</style>

<section class="wrap TW">
  <div class="main">
    <h2 class="title">{LG(lang.PhemexBrand3T)}</h2>
    <div class="df jcsb">
      <img class="brand-logo" width="512" height="700" src={IMAGES.IPHONE} alt="crypto trading app" />
      <Collapse class="f1" accordion activeIds={['1']}>
        <Panel panelId="1">
          <h3 slot="panel-title" class="brand-title">{LG(lang.Trustworthy)}</h3>
          {#each brandList.safe as item}
            <div class="brand-content df pv16">
              <div class="f1">
                <div>{item.desc}</div>
              </div>
            </div>
          {/each}
        </Panel>
        <Panel panelId="2">
          <h3 slot="panel-title" class="brand-title">{LG(lang.Transparency)}</h3>
          {#each brandList.super as item}
            <div class="brand-content df pv16">
              <div class="f1">
                <div>{item.desc}</div>
              </div>
            </div>
          {/each}
        </Panel>
        <Panel panelId="3">
          <h3 slot="panel-title" class="brand-title">{LG(lang.Together)}</h3>
          {#each brandList.simple as item}
            <div class="brand-content df pv16">
              <div class="f1">
                <div>{item.desc}</div>
              </div>
            </div>
          {/each}
        </Panel>
      </Collapse>
    </div>
  </div>
</section>
